export default {"src":"/_next/static/media/people_64.534f365e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};